/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.directive('adUnit', [function() {
        return {
            restrict: 'E',
            scope: {
                siteId: '=',
                pageId: '=',
                formatId: '=',
                pageName: '=', // Find this in the <noscript> section of the ad snippet
                targetCategory: '=',
                targetBrand: '=',
                targetScore: '='
            },
            controller: [
                '$scope',
                'AccountAuthService',
                '$timeout',
                '$q',
                function (
                    $scope,
                    AccountAuthService,
                    $timeout,
                    $q
                ) {
                    $scope.target = '';
                    var vm = this;

                    if (AccountAuthService.isLoggedInResponse.is_authenticated) {
                        $scope.target += 'logged-in=true;';
                    } else {
                        $scope.target += 'logged-in=false;';
                    }

                    if ($scope.targetCategory) {
                        $scope.target += ('category=' + $scope.targetCategory + ';');
                    }

                    if ($scope.targetBrand) {
                        $scope.target += ('brand=' + $scope.targetBrand + ';');
                    }

                    if ($scope.targetScore) {
                        $scope.target += ('score=' + $scope.targetScore + ';');
                    }

                    /**
                     * Helper function to wait until the image for this
                     * directive's ad has loaded.
                     *
                     * @param {Element} element the element to search for the
                     * image within. To be passed in from the link function.
                     * @param {$q.defer} [deferred] a deferred promise from the
                     * $q library
                     * @return {Promise} a promise that resolves to the image
                     * element once it is found.
                     */
                    vm.waitForAdImage = function(element, deferred) {
                        if (typeof deferred === 'undefined') {
                            deferred = $q.defer();
                        }
                        $timeout(function() {
                            if (element.find('img').length > 0) {
                                deferred.resolve(element.find('img')[0]);
                            } else {
                                vm.waitForAdImage(element, deferred);
                            }
                        }, 300);

                        return deferred.promise;
                    };

                }],
            link: function($scope, element, attrs, controller) {
                // Create and apply a unique id to the ad container
                var _elementId = $scope.siteId + '_' + $scope.pageId + '_' + $scope.formatId;
                $(element).attr('id', _elementId);

                // Generate the ad in the ad container
                if ($scope.siteId && $scope.pageId && $scope.formatId) {
                    sas.call("std", {
                        siteId: $scope.siteId,
                        pageId: $scope.pageId,
                        formatId: $scope.formatId,
                        target: $scope.target,
                        tagId: _elementId
                    });

                    controller.waitForAdImage(element).then(function(img) {
                        angular.element(img).attr('alt', 'See more');
                    });
                }
            },
            template: require('@app/shared/adUnits/adUnit.html'),
        };

    }]);

})(angular);
